import { createStore } from 'vuex'

import getters from './getters'
import actions from './actions'
import mutations from './mutations'

import user from './modules/user/user'
import product from './modules/product/product'
import task from './modules/task/task'
import material from './modules/material/material'
import category from './modules/category/category'
import company from './modules/company/company'
import setting from './modules/setting/setting'
import compare from './modules/compare/compare'

export const store = createStore({
  state: {
    baseUrl: process.env.VUE_APP_BASE_URL,
    // Image thumbnails must load from API; same logic for onboarding and Settings display (both use app-images)
    imagesUrl: (function () {
      const env = process.env.VUE_APP_IMAGE_URL;
      if (env && env.indexOf('http') === 0) return env;
      const base = process.env.VUE_APP_BASE_URL ? String(process.env.VUE_APP_BASE_URL).replace(/\/$/, '') : '';
      if (base) return base + '/storage/images/';
      // Same-origin API at /api (e.g. DO): use full origin so img src always hits the backend
      if (typeof window !== 'undefined' && window.location && window.location.origin) {
        return window.location.origin + '/api/storage/images/';
      }
      return '/storage/images/';
    })(),
    subscriptionStatus: null, // { trial_ends_at, trial_used, days_remaining, subscription_active, must_upgrade }
    states: [
      { id: 'VIC', name: 'VIC' },
      { id: 'NSW', name: 'NSW' },
      { id: 'QLD', name: 'QLD' },
      { id: 'SA', name: 'SA' },
      { id: 'WA', name: 'WA' },
      { id: 'TAS', name: 'TAS' },
      { id: 'ACT', name: 'ACT' },
      { id: 'NT', name: 'NT' }
    ],
    validationErrors: null,
    overlay: false,
    header: true,
    footer: true,
    stripePk: process.env.VUE_APP_STRIPE_KEY
  },
  getters,
  mutations,
  actions,
  modules: {
    user: {
      namespaced: true,
      state: user.state,
      getters: user.getters,
      mutations: user.mutations,
      actions: user.actions
    },
    product: {
      namespaced: true,
      state: product.state,
      getters: product.getters,
      mutations: product.mutations,
      actions: product.actions
    },
    task: {
      namespaced: true,
      state: task.state,
      getters: task.getters,
      mutations: task.mutations,
      actions: task.actions
    },
    material: {
      namespaced: true,
      state: material.state,
      getters: material.getters,
      mutations: material.mutations,
      actions: material.actions
    },
    category: {
      namespaced: true,
      state: category.state,
      getters: category.getters,
      mutations: category.mutations,
      actions: category.actions
    },
    company: {
      namespaced: true,
      state: company.state,
      getters: company.getters,
      mutations: company.mutations,
      actions: company.actions
    },
    setting: {
      namespaced: true,
      state: setting.state,
      getters: setting.getters,
      mutations: setting.mutations,
      actions: setting.actions
    },
    compare: {
      namespaced: true,
      state: compare.state,
      getters: compare.getters,
      mutations: compare.mutations
    }
  }
})
